import React from 'react';
import { FeedbackText, FeedbackContainer, Emoji, ButtonContainer } from '../../styled/feedback';
import { NextButton } from '../../styled/stepper';
import { Link } from 'react-router';

const Feedback = ({ error }) => {
  console.log('Error: ', error);
  return (
    <FeedbackContainer>
      <div>
        {!error ? <Emoji>📨</Emoji> : <Emoji>😞</Emoji>}
        <FeedbackText>
          {!error
            ? '¡Enviado! Comprueba tu correo y consulta cuál puede ser tu renta con Badi Plus'
            : 'Ha ocurrido un error enviendo el formulario. Inténtalo de nuevo más tarde.'}
        </FeedbackText>
      </div>
      <ButtonContainer>
        <NextButton
          aria-label="Calcula tu renta"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.location.reload();
          }}
        >
          Calcular de nuevo
        </NextButton>
        <NextButton>
          <a
            rel="noopener noreferrer"
            aria-label="Volver a Badi Plus"
            href="https://plus.badi.com/es/propietarios/"
          >
            Volver a Badi Plus
          </a>
        </NextButton>
      </ButtonContainer>
    </FeedbackContainer>
  );
};

export default Feedback;
